@import url("https://cdn.jsdelivr.net/npm/bootstrap@5.1.3/dist/css/bootstrap.min.css");
/* @import url("../../../node_modules/bootstrap/dist/css/bootstrap.min.css");  */

:host {
  display: block;
}

a,
a:visited {
  color: #b71d1d;
  font-size: 16px;
  text-decoration: none;
}

a:hover {
  color: #b71d1d;
  font-size: 16px;
}


.img-rounded-border {
  border: 10px solid red;
  border-radius: 10px;
}

#about-image {
  /* width: 250px; */
  margin-top: 20px;
}

::-webkit-scrollbar {
  width: 2px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #D3D3D3;
}

.marquee-nyp {
  height: 35px;
  overflow: hidden;
  position: relative;
  background: black;
  color: white;
  padding-top: 5px;
  
}

.marquee-nyp p {
  position: absolute;
  width: 100%;
  height: 100%;
  margin: 0;
  line-height: 35px;
  text-align: center;
  -moz-transform: translateX(100%);
  -webkit-transform: translateX(100%);
  transform: translateX(100%);
  -moz-animation: scroll-left 30s linear infinite;
  -webkit-animation: scroll-left 30s linear infinite;
  animation: scroll-left 30s linear infinite;
}

.marquee-nyp p:hover {
         
  -moz-animation-play-state: paused;
  -webkit-animation-play-state: paused;
  animation-play-state: paused;
}


@-moz-keyframes scroll-left {
  0% {
      -moz-transform: translateX(100%);
  }
  100% {
      -moz-transform: translateX(-100%);
  }
}

@-webkit-keyframes scroll-left {
  0% {
      -webkit-transform: translateX(100%);
  }
  100% {
      -webkit-transform: translateX(-100%);
  }
}

@keyframes scroll-left {
  0% {
      -moz-transform: translateX(100%);
      -webkit-transform: translateX(100%);
      transform: translateX(100%);
  }
  100% {
      -moz-transform: translateX(-100%);
      -webkit-transform: translateX(-100%);
      transform: translateX(-100%);
  }
}
.raw-html-style-ticker a{
 
    color: white !important;
    font-size: 16px;
    text-decoration: underline !important;
    position: relative; 
  
  
}
